import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';
import { cn } from '../../../lib/utils';
import {
    CATEGORY_COLOR_KEYS,
    CATEGORY_COLORS,
    CategoryColorKey,
} from './categoryColors';

interface SwatchGridProps {
    selected: CategoryColorKey | null;
    taken: Set<CategoryColorKey>;
    onSelect: (color: CategoryColorKey) => void;
}

export const SwatchGrid = ({ selected, taken, onSelect }: SwatchGridProps) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-wrap gap-1.5">
            {CATEGORY_COLOR_KEYS.map((color) => {
                const isTaken = taken.has(color);
                const isSelected = selected === color;
                return (
                    <button
                        key={color}
                        type="button"
                        onClick={() => !isTaken && onSelect(color)}
                        disabled={isTaken}
                        title={
                            isTaken
                                ? t('folders.category.colorTaken')
                                : undefined
                        }
                        className={cn(
                            'flex h-6 w-6 items-center justify-center rounded-full transition-opacity',
                            CATEGORY_COLORS[color].swatch,
                            isTaken && 'cursor-not-allowed',
                            !isTaken && 'hover:opacity-90',
                            isSelected &&
                                'ring-2 ring-offset-2 ring-offset-background ring-zinc-100'
                        )}
                        aria-label={color}
                        aria-pressed={isSelected}
                    >
                        {isSelected && (
                            <Check
                                className="h-3 w-3 text-zinc-900"
                                aria-hidden="true"
                            />
                        )}
                        {isTaken && !isSelected && (
                            <X
                                className="h-3 w-3 text-white"
                                aria-hidden="true"
                            />
                        )}
                    </button>
                );
            })}
        </div>
    );
};
